import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,
  List, ListItemButton, ListItemIcon, ListItemText, Checkbox,
} from '@mui/material';

const CloneDispatchDialog = ({
  open, onClose, dispatchItem, options, onConfirm,
}) => {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (open) setSelected([]);
  }, [open]);

  const toggle = (value) => {
    setSelected(prev => (prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Clone dispatch to other dealerships</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 1, overflowWrap: 'anywhere' }}>
          Copy &quot;
          {dispatchItem ? dispatchItem.name : ''}
          &quot; and its rules to the dealerships you select. Targets that reference a department from the original store may need adjusting afterward.
        </Typography>
        {options.length === 0 ? (
          <Typography variant="body2" color="textSecondary">No other dealerships available.</Typography>
        ) : (
          <List dense sx={{ maxHeight: 320, overflow: 'auto' }}>
            {options.map(o => (
              <ListItemButton key={o.value} onClick={() => toggle(o.value)}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <Checkbox edge="start" size="small" checked={selected.includes(o.value)} tabIndex={-1} disableRipple />
                </ListItemIcon>
                <ListItemText primary={o.label} />
              </ListItemButton>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={() => onConfirm(selected)} disabled={selected.length === 0}>
          {`Clone${selected.length ? ` (${selected.length})` : ''}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloneDispatchDialog;
